import { DAY_CLOSING_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

export interface IOverdueReason {
  reason: string;
  sub_reasons: string[];
}

AxiosCurlirize(axios, () => {});

export const useOverdueReasonsAPI = () => {
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const [overdueReasons, setOverdueReasons] = useState<IOverdueReason[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const execute = useCallback(async (invoice_id: string, customer_id?: string) => {
    setIsLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const params = new URLSearchParams({ invoice_id });
      if (customer_id) params.append("customer_id", customer_id);
      const response: any = await axios
        .get(`${DAY_CLOSING_APIS?.OVERDUE_REASONS?.baseURL}?${params.toString()}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<any>) => {
          if (res.data.status) {
            setOverdueReasons(res.data.data ?? []);
            return { status: true };
          }
          setOverdueReasons([]);
          return { status: false };
        })
        .catch((e: AxiosError) => {
          setOverdueReasons([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e);
          return { status: false };
        });
      return response;
    } catch (e: any) {
      setOverdueReasons([]);
      captureError(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { execute, overdueReasons, isLoading };
};
